<template>
  <div class="mask" v-if="msg.show">
    <van-dialog
      v-model:show="msg.show"
      :title="$t('app.errorinfopopup.title')"
      :confirm-button-text="$t('app.errorinfopopup.detail')"
      @confirm="onConfirmClick"
      :before-close="onBeforeClose"
      show-cancel-button
      :cancel-button-text="$t('app.errorinfopopup.close')"
    >
      <div>
        <h3>{{ msgdata.traceId }}</h3>
        <p>
          {{ msgdata.code + "--" + msgdata.message }}
        </p>

        <transition name="slide">
          <div v-show="msg.showdetail" class="detail">
            {{ msgdata.detail }}
          </div>
        </transition>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { reactive, ref } from "@vue/reactivity";
// 别人要去操作你的状态的
export const usePopupEffect = () => {
  const msg = reactive({
    show: false,
    showdetail: false,
  });
  const msgdata = reactive({
    traceId: "",
    code: "",
    message: "",
    detail: "",
  });
  return { msg, msgdata };
};
export default {
  name: "MyErrorDetailPopup",
  // 必须要传参数的
  props: {
    msg: Object,
    msgdata: Object,
  },
  setup(props, context) {
    const onBeforeClose = (action, done) => {
      if ("confirm" == action) {
        // 点击了详情
        return false;
      }
      return true;
    };
    const onConfirmClick = () => {
      console.log("onConfirmClick");
      props.msg.showdetail = !props.msg.showdetail;
    };
    return { onConfirmClick, onBeforeClose };
  },
};
</script>
<style lang="scss" scoped>
.mask {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 99;
}
h3,
p {
  margin: 0;
  padding: 0;
}
h3 {
  font-size: 0.15rem;
  text-align: center;
}
p {
  font-size: 0.14rem;
  padding-top: 0.1rem;
  padding-left: 0.1rem;
}
.detail {
  max-height: 1.2rem;
  padding: 0.1rem;
  overflow-y: scroll;
  font-size: 0.13rem;
}
@keyframes slide-down {
  from {
    max-height: 0;
    // opacity: 0;
  }
  to {
    max-height: 1.2rem;
    // opacity: 1;
  }
}

@keyframes slide-up {
  from {
    max-height: 1.2rem;
    // opacity: 1;
  }
  to {
    max-height: 0;
    // opacity: 0;
  }
}

.slide-enter-active {
  animation: slide-down 0.6s ease-in-out forwards;
}

.slide-leave-active {
  animation: slide-up 0.6s ease-in-out forwards;
}
</style>